










import Vue from 'vue'
import axios from 'axios'
import Component from 'vue-class-component'
import Form from '../components/Form.vue'
import { IModule } from '../../modules/types'
import { ICourse } from '../types'

@Component({
  components: {
    Form
  }
})
export default class Create extends Vue {
  data: ICourse = {}

  modules: IModule[] = []

  adminView: boolean = false
  
  async reloadData() {
    this.data = (await axios.get(`courses/${this.$route.params.courseId}`)).data
    this.adminView = this.$store.state.auth.isAdmin
    await this.getModules()
  }

  async mounted() {
    this.reloadData()
  }

  async submit(data: ICourse) {
    try {
      if (this.data.id) {
        await axios.patch(`courses/${data.id}`, data)
        this.$store.dispatch('showSuccess', 'Course updated successfully!')
      } else {
        await axios.post('courses', data)
        this.$store.dispatch('showSuccess', 'Course created successfully!')
      }
      this.data = data
      await this.getModules()
    } catch (err) {
      this.$store.dispatch('showError', err.reponse.data.message)
    }
  }

  async getModules() {
    const unsortedModules: IModule[] = (await axios.get(`courses/${this.$route.params.courseId}/modules`)).data.result
    this.modules = unsortedModules.sort((a, b) => (a.moduleOrder || 0) - (b.moduleOrder || 0))
  }
}
